module.exports = __webpack_public_path__ + "static/gab-1-155dece6a9e96d3fcdb227c73e382b6b.jpg";